import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import AppState from 'js/stores/AppState';
import AppUser from 'js/stores/AppUser';
import analytics from 'js/services/Analytics';

import Button from 'js/components/common/Button';
import { primaryColor } from 'js/config/style';
import { action } from 'mobx';

const passPredicate = () => true;
const noop = () => null;

@observer
export default class FacebookConnectButton extends Component {
  @observable
  isConnecting = false;
  @action
  setIsConnecting(isConnecting) {
    this.isConnecting = isConnecting;
  }

  onConnect = response => {
    let tracking;

    analytics.identify(response);
    //log response, let's see

    const prefix = analytics.loginPrefix();

    if (response.is_new_user) {
      tracking = analytics
        .track(`${prefix}account_created_fb`, {
          'Email': response.email,
          'Signup Method': 'Facebook',
          'Name': "",
          'Address': "",
          'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : 'create-link',
          'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
            ? 'seller' : 'buyer'
        });
    } else {
      tracking = analytics
        .track(`${prefix}logged_in_fb`, {
          'Email': response.email,
          'Signup Method': 'Facebook',
          'Name': "",
          'Address': "",
          'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : window.location.href,
          'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
            ? 'seller' : 'buyer'
        });
    }
    analytics.track('CTA_Engaged_User', {
      'Email': response.email,
      'Signup/Login Method': 'Facebook',
      'Date': new Date().toString(),
      'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : window.location.href,
      'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
        ? 'seller' : 'buyer'
    })
    return tracking.then(this.props.onConnect);
  };

  loginNow = () => {
    this.setIsConnecting(true);
    const prefix = analytics.loginPrefix();

    analytics
      .track(`CTA_${prefix}signup_FB`, {
        'Email': '',
        'Signup Method': 'Facebook',
        'Name': this.props.page ? this.props.page.full_name : '',
        'Address': this.props.page ? this.props.page.address : '',
        'mseller': this.props.mseller,
        'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : window.location.href,
        'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
          ? 'seller' : 'buyer'
      });

    AppUser.loginUser(this.props.scope || 'email', this.props.addParams, 'facebook')
      .then(this.onConnect)
      .catch(error => {
        console.error(error);
        (this.props.onError || noop)(error.response ? error.response.data.message : 'Could not connect with Facebook');
        this.setIsConnecting(false);
      });
  };

  triggerLogin = () => Promise.all([(this.props.beforeConnect || noop)()]).then(() => this.loginNow());

  onClick = () => !this.props.disabled && (this.props.predicate || passPredicate)() && this.triggerLogin();

  render() {
    let {
      children,
      icon,
      color,
      predicate,
      isLoading,
      gotoSellItem,
      fullWidth,
      onConnect,
      addParams,
      beforeConnect,
      mseller,
      ...rest
    } = this.props;

    isLoading = isLoading || this.isConnecting;

    return (
      <Button
        color={color || primaryColor.hex()}
        icon={typeof icon !== 'undefined' ? icon : 'facebook-square'}
        isLoading={isLoading}
        onClick={this.onClick}
        {...rest}>
        {isLoading ? 'Connecting With Facebook' : children || 'Continue with Facebook'}
      </Button>
    );
  }
}
